export default __webpack_public_path__ + "static/media/Godot.e41cbb19.png";